import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function WhoForNotForSection() {
  const forList = ['Padres y madres de niños entre 2 y 6 años que se sienten agotados.', 'Abuelos o cuidadores que quieren aplicar una crianza moderna basada en el respeto.', 'Familias que desean un hogar en paz, libre de gritos constantes.', 'Personas que sienten que han perdido el control de la disciplina en casa.'];
  const notForList = ['Quienes buscan métodos de adiestramiento basados en el miedo o el castigo físico.', 'Personas que no están dispuestas a trabajar primero en su propia calma.', 'Quienes buscan una "solución mágica" de un día para otro sin compromiso emocional.'];
  return <section className="bg-white py-24 px-6" data-id="element-146">
      <div className="max-w-6xl mx-auto" data-id="element-147">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-148">
          {/* FOR */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="bg-cream p-8 md:p-10 rounded-3xl" data-id="element-149">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-brown-dark" data-id="element-150">
              Esto es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-151">
              {forList.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-152">
                  <CheckCircle2Icon className="w-6 h-6 text-dusty-green flex-shrink-0 mt-1 mr-4" data-id="element-153" />
                  <span className="text-lg text-brown" data-id="element-154">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NOT FOR */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} className="bg-red-50/50 p-8 md:p-10 rounded-3xl border border-red-100" data-id="element-155">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-brown-dark" data-id="element-156">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-157">
              {notForList.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-158">
                  <XCircleIcon className="w-6 h-6 text-dusty-red flex-shrink-0 mt-1 mr-4" data-id="element-159" />
                  <span className="text-lg text-brown" data-id="element-160">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Descarga el Kit',
    desc: 'Recibe el acceso inmediato en tu correo tras el pago.'
  }, {
    num: '2',
    title: 'Aplica el Ancla',
    desc: 'La próxima vez que empiece el llanto, usa las técnicas corporales y de voz que aprenderás.'
  }, {
    num: '3',
    title: 'Recupera la Paz',
    desc: 'Mira cómo tu hijo se regula más rápido y cómo tú terminas el día sin esa pesada sensación de culpa.'
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-161">
      <div className="max-w-5xl mx-auto" data-id="element-162">
        <motion.h2 initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-163">
          ¿Cómo funciona?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-164">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2,
          duration: 0.6
        }} className="flex flex-col items-center text-center" data-id="element-165">
              <div className="w-20 h-20 bg-teal-dark text-white rounded-full flex items-center justify-center text-3xl font-serif font-bold mb-6 shadow-lg" data-id="element-166">
                {step.num}
              </div>
              <h4 className="text-2xl font-bold mb-4" data-id="element-167">{step.title}</h4>
              <p className="text-brown text-lg leading-relaxed" data-id="element-168">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}